import { render } from "./UsuarioDashView.vue?vue&type=template&id=048c9e1d&scoped=true"
import script from "./UsuarioDashView.vue?vue&type=script&lang=js"
export * from "./UsuarioDashView.vue?vue&type=script&lang=js"

import "./UsuarioDashView.vue?vue&type=style&index=0&id=048c9e1d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-048c9e1d"]])

export default __exports__